(function() {
  if (window.__bundleAtcInit) return;
  window.__bundleAtcInit = true;

  var bundles = {
    night: [
      { id: 46382863450302, quantity: 1 },
      { id: 46429585998014, quantity: 1 }
    ],
    'night-sub': [
      { id: 46382863450302, quantity: 1, selling_plan: 13466763454 },
      { id: 46429585998014, quantity: 1, selling_plan: 13471449278 }
    ],
    day: [
      { id: 46394700955838, quantity: 1 },
      { id: 46391715168446, quantity: 1 }
    ],
    'day-sub': [
      { id: 46394700955838, quantity: 1, selling_plan: 13471482046 },
      { id: 46391715168446, quantity: 1, selling_plan: 13471514814 }
    ],
    full: [
      { id: 46382863450302, quantity: 1 },
      { id: 46429585998014, quantity: 1 },
      { id: 46394700955838, quantity: 1 },
      { id: 46391715168446, quantity: 1 }
    ],
    'full-sub': [
      { id: 46382863450302, quantity: 1, selling_plan: 13466763454 },
      { id: 46429585998014, quantity: 1, selling_plan: 13471449278 },
      { id: 46394700955838, quantity: 1, selling_plan: 13471482046 },
      { id: 46391715168446, quantity: 1, selling_plan: 13471514814 }
    ]
  };

  document.addEventListener('click', function(e) {
    var bundleBtn = e.target.closest('[data-bundle-atc]');
    if (bundleBtn) {
      e.preventDefault();
      var bundle = bundleBtn.getAttribute('data-bundle-atc');
      var items = bundles[bundle];
      if (items) addToCart(bundleBtn, items);
      return;
    }

    var productBtn = e.target.closest('[data-product-atc]');
    if (productBtn) {
      e.preventDefault();
      var variantId = parseInt(productBtn.getAttribute('data-product-atc'), 10);
      if (variantId) addToCart(productBtn, [{ id: variantId, quantity: 1 }]);
      return;
    }
  });

  function addToCart(btn, items) {
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6';
    var originalText = btn.textContent;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      window.location.href = '/cart';
    })
    .catch(function() {
      btn.textContent = originalText;
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    });
  }
})();
